import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/icon_arrow_pointed_white.svg'


const _hoisted_1 = { class: "msg" }
const _hoisted_2 = { class: "base" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TopHeader = _resolveComponent("TopHeader")!
  const _component_LoginStepBlowingItem = _resolveComponent("LoginStepBlowingItem")!
  const _component_LoginStepBlowingList = _resolveComponent("LoginStepBlowingList")!
  const _component_TextBox = _resolveComponent("TextBox")!
  const _component_InputItem = _resolveComponent("InputItem")!
  const _component_ArrowSimpleLink = _resolveComponent("ArrowSimpleLink")!
  const _component_BasicButton = _resolveComponent("BasicButton")!
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_LoginLayout = _resolveComponent("LoginLayout")!
  const _component_SiteMap = _resolveComponent("SiteMap")!
  const _component_SiteFooter = _resolveComponent("SiteFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TopHeader),
    _createVNode(_component_LoginLayout, {
      isDisplay: false,
      isWide900: true,
      isChangeSpPadding: _ctx.sp
    }, {
      contents: _withCtx(() => [
        _cache[10] || (_cache[10] = _createElementVNode("h2", null, "USEN MEMBERS 会員登録フォーム", -1)),
        _createVNode(_component_LoginStepBlowingList, { class: "step-position" }, {
          default: _withCtx(() => [
            _createVNode(_component_LoginStepBlowingItem, {
              count: 1,
              title: !_ctx.sp ? 'お客様情報の入力' : 'お客様情報\nの入力',
              isColorGray: false
            }, null, 8, ["title"]),
            _createVNode(_component_LoginStepBlowingItem, {
              count: 2,
              title: !_ctx.sp ? '認証コード入力' : '認証コード\n入力',
              isColorGray: true
            }, null, 8, ["title"]),
            _createVNode(_component_LoginStepBlowingItem, {
              count: 3,
              title: !_ctx.sp ? 'お客様情報確認' : 'お客様情報\n確認',
              isColorGray: true
            }, null, 8, ["title"]),
            _createVNode(_component_LoginStepBlowingItem, {
              count: 4,
              title: '仮登録完了',
              isColorGray: true,
              isBorder: false
            })
          ]),
          _: 1
        }),
        _cache[11] || (_cache[11] = _createElementVNode("p", { class: "msg" }, [
          _createTextVNode(" 会員登録する店舗情報の入力をお願いします。"),
          _createElementVNode("br"),
          _createTextVNode(" 入力されたメールアドレス宛に認証コードをお送りします"),
          _createElementVNode("br"),
          _createTextVNode(" お客様情報を照会後、ユーザーIDとパスワードを設定いただくと登録完了となります。 ")
        ], -1)),
        _createVNode(_component_InputItem, {
          title: "店舗名",
          description: "例：株式会社USEN ※（株）などの入力は不要です",
          errorMessage: "店舗名を入力してください",
          isRequired: true,
          isChangeFont: true,
          isError: _ctx.isErrorStoreName
        }, {
          default: _withCtx(() => [
            _createVNode(_component_TextBox, {
              modelValue: _ctx.params.storeName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.params.storeName) = $event)),
              title: "",
              isMurkyBlue: !_ctx.isError,
              isError: _ctx.isErrorStoreName
            }, null, 8, ["modelValue", "isMurkyBlue", "isError"])
          ]),
          _: 1
        }, 8, ["isError"]),
        _createVNode(_component_InputItem, {
          title: "店舗名 カナ",
          description: "例：カブシキカイシャユーセン ※カ）などの入力は不要です",
          errorMessage: "店舗名 カナをカタカナで入力してください",
          isRequired: true,
          isChangeFont: true,
          isError: _ctx.isErrorStoreNameKana
        }, {
          default: _withCtx(() => [
            _createVNode(_component_TextBox, {
              modelValue: _ctx.params.storeNameKana,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.params.storeNameKana) = $event)),
              title: "",
              isMurkyBlue: !_ctx.isError,
              isError: _ctx.isErrorStoreNameKana
            }, null, 8, ["modelValue", "isMurkyBlue", "isError"])
          ]),
          _: 1
        }, 8, ["isError"]),
        _createVNode(_component_InputItem, {
          title: "店舗の電話番号",
          description: "店舗の電話番号を半角数字で入力してください (半角数字・ハイフンなし)",
          errorMessage: "店舗の電話番号を半角数字で入力してください",
          isRequired: true,
          isChangeFont: true,
          isError: _ctx.isErrorPhoneNumber
        }, {
          default: _withCtx(() => [
            _createVNode(_component_TextBox, {
              modelValue: _ctx.params.phoneNumber,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.params.phoneNumber) = $event)),
              title: "",
              isMurkyBlue: !_ctx.isError,
              isError: _ctx.isErrorPhoneNumber
            }, null, 8, ["modelValue", "isMurkyBlue", "isError"])
          ]),
          _: 1
        }, 8, ["isError"]),
        _createVNode(_component_InputItem, {
          title: "メールアドレス",
          description: "例：abc@example.com",
          isRequired: true,
          isChangeFont: true,
          errorMessage: "メールアドレスを入力してください",
          isError: _ctx.isErrorMailAddress
        }, {
          default: _withCtx(() => [
            _createVNode(_component_TextBox, {
              modelValue: _ctx.params.mailAddress,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.params.mailAddress) = $event)),
              title: "",
              isMurkyBlue: !_ctx.isError,
              isError: _ctx.isErrorMailAddress
            }, null, 8, ["modelValue", "isMurkyBlue", "isError"])
          ]),
          _: 1
        }, 8, ["isError"]),
        _createVNode(_component_InputItem, {
          title: "9桁のお客様番号（顧客コード）",
          description: "半角数字で入力ください",
          isRequired: true,
          isChangeFont: true,
          errorMessage: "半角数字9桁で顧客コードを入力してください",
          isError: _ctx.isErrorUnisCustomerCode
        }, {
          default: _withCtx(() => [
            _cache[5] || (_cache[5] = _createTextVNode(" お客様番号の確認方法は")),
            _cache[6] || (_cache[6] = _createElementVNode("a", {
              class: "link-blue",
              href: "/pdf/howtoaccount.pdf",
              target: "_blank"
            }, "こちら", -1)),
            _createVNode(_component_TextBox, {
              modelValue: _ctx.params.unisCustomerCode,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.params.unisCustomerCode) = $event)),
              title: "",
              isMurkyBlue: !_ctx.isError,
              isError: _ctx.isErrorUnisCustomerCode
            }, null, 8, ["modelValue", "isMurkyBlue", "isError"])
          ]),
          _: 1
        }, 8, ["isError"]),
        _createElementVNode("p", _hoisted_1, [
          _createVNode(_component_ArrowSimpleLink, {
            url: 'https://usen.com/contact/service-uic/input.php?utm_source=form&utm_medium=referral&utm_campaign=umform',
            "arrow-type": 'small-blue',
            isArrowDeepBlue: true,
            fontSize: 14,
            isExternal: true,
            class: "query-marge",
            isBlueBorder: true
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createElementVNode("span", { class: "font-width" }, " 顧客コードがわからない場合はこちらよりお問い合わせをお願いいたします。", -1)
            ])),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_2, [
          _cache[9] || (_cache[9] = _createElementVNode("p", { class: "strong-msg" }, "上記内容でよろしければ「確認する」ボタンをクリックしてください。", -1)),
          _createVNode(_component_BasicButton, {
            width: 196,
            buttonType: "deepBlueWhite",
            onClick: _ctx.confirm
          }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [
              _createElementVNode("div", { class: "button-content" }, [
                _createElementVNode("p", { class: "button-text" }, "確認する"),
                _createElementVNode("img", {
                  class: "arrow-white",
                  src: _imports_0,
                  alt: "arrow-white"
                })
              ], -1)
            ])),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createVNode(_component_LoadingSpinner, { isLoading: _ctx.isLoading }, null, 8, ["isLoading"])
      ]),
      _: 1
    }, 8, ["isChangeSpPadding"]),
    _createVNode(_component_SiteMap),
    _createVNode(_component_SiteFooter)
  ], 64))
}